import config from '../data/config.json';
import dict from '../data/dictionary.json';
import { patchPopupTemplate } from '../data/htmlTemplates.js';

import Mustache from 'mustache';

import { Sesion, Datos, Layers } from '../main.js';
import { Mimapa } from './map.js';
import { correspondenciaTaxonMulti, correspondenciaTaxon, getTaxonLabel } from './taxons.js';
import { getLiteral, getDate, uriToLiteral, firstUppercase, getColor, getColorMix, getPreferredLang, applyPrefix } from './util.js';

// TESELAS
function inicializarTeselas() {
	// devuelvo la capa GEOJSON para las teselas
	return L.geoJson(null, {
		style: function(feature) {			
			if (Sesion.estado.mapType === config.mapConfig.mapType[1]) // capa satélite
				return {
					fillColor: config.colores[config.coltesimpind][6], // color de relleno  
					weight: 0.4, // 0.3,
					opacity: 1,
					color: config.colores[config.coltesimpind][1],
					dashArray: '1',
					fillOpacity: 0.05 // 0.1
				};
			else {
				// recupero objeto tesela
				const otes = Datos.teselas[feature.properties.iri];
				return {
					fillColor: colorTesela(otes, false), // color de relleno  
					weight: 0.5,
					opacity: 1,
					color: colorTesela(otes, true), // color de borde
					dashArray: '1',
					fillOpacity: 0.3
				};
			}
		}
	}).addTo(Mimapa);
}
function colorTesela(tesela, esBorde) {
	// capa satélite (por el cambio de color desde taxon)
	if (Sesion.estado.mapType === config.mapConfig.mapType[1]) // capa satélite
		return esBorde? config.colores[config.coltesimpind][1] : config.colores[config.coltesimpind][6];	
	
	// caso por defecto
	// ¿hay uso?
	if (tesela.soilUse == undefined || Datos.usos[config.forestuse] == undefined) {
		if (tesela.soilUse == undefined)
			console.warn("PROBLEMA CON USO DE TESELA "+tesela.iri);
		if (Datos.usos[config.forestuse] == undefined)
			console.warn("PROBLEMA CON LOS DATOS DE USOS DEL DATASET");
		// devuelvo un color, en cualquier caso
		if (esBorde)
			return config.colores[config.colindefind][4];
		else
			return config.colores[config.colindefind][3];
	}
	
	// incluyo los usos de la tesela en un array
	const tesusos = Array.isArray(tesela.soilUse)? tesela.soilUse : [ tesela.soilUse ];

	// niveles por defecto
	let nivBorde = 3;
	let nivNormal = 2;
	let nivFiltrado = 7;
	let nivNoFiltrado = 1;
	let nivBordeNoFiltrado = 2;
	
	// valores por defecto
	let ind0 = config.colindefind; // valor por defecto (color gris)
	let ind1 = esBorde? nivBorde : nivNormal; // valor por defecto (intensidad)
	
	// compruebo tipo de uso
	//if (Datos.usos[config.forestuse].expuris.filter(uuri => tesusos.includes(uuri)).length > 0) { // uso forestal
	if (tesela.forestal) { // uso forestal
		// SELECCIÓN DE COLORES SI HAY FILTRO DE TAXÓN
		if (Sesion.taxones.length > 0) {	
			// preparo colores a mezclar
			let cols = [];
			for (let ind =0; ind < Sesion.taxones.length; ind++) {
				const tx = Sesion.taxones[ind];
				// calculo porcentaje de cada taxón filtrado para la tesela				
				let porc = 0;
				// HAY QUE TENER EN CUENTA QUE EL MFE Y EL COS ESTÁN ANOTADOS CON TX DEL IFN3
				// debido a esto tengo que convertir los taxones expuris de tx al ifn3
				const txexpurisifn3 = Sesion.taxonesCorrExpuris[ind];
				//const txexpurisifn3 = corrtxmulti? corrtxmulti[ind] : correspondenciaTaxonMulti(Datos.taxones[tx].expuris, "ifn3");
				if (tesela.infoSpecies) { // caso español, analizo especies de la tesela
					const infosar = Array.isArray(tesela.infoSpecies)? tesela.infoSpecies : [ tesela.infoSpecies ];
					for (let is of infosar) {
						// si hay coincidencia con la especie filtrada, adentro
						if (txexpurisifn3.includes(is.species)) {
							if (esBorde) { // si es borde...
								cols.push(config.colores[Sesion.taxonesColores[ind]][nivBorde]);
								break;
							}
							else // en otro caso
								porc += is.percOccupation;
						}
					}
				}
				else if (tesela.infoSoil) { // 2021-05-24 revisión caso portugués, la información de especie puede estar en el uso...
					const infosoilar = Array.isArray(tesela.infoSoil)? tesela.infoSoil : [ tesela.infoSoil ];
					// tesela agregada con porcentajes de uso
					for (let isoil of infosoilar) {
						if (Datos.usos[isoil.soilUse] && Datos.usos[isoil.soilUse].species) {
							const spa = Array.isArray(Datos.usos[isoil.soilUse].species)? Datos.usos[isoil.soilUse].species : [Datos.usos[isoil.soilUse].species];
							// si hay coincidencia con la especie filtrada, adentro
							if (txexpurisifn3.find(txuri => spa.includes(txuri))) {
								if (esBorde) { // si es borde...
									cols.push(config.colores[Sesion.taxonesColores[ind]][nivBorde]);
									break;
								}
								else // en otro caso
									porc += isoil.percOccupation;
							}
						}
					}			
				}
				else { // caso portugués, no es tesela agregada => utilizo sin más el uso
					for (let tuso of tesusos) {
						if (Datos.usos[tuso] && Datos.usos[tuso].species) {
							const spa = Array.isArray(Datos.usos[tuso].species)? Datos.usos[tuso].species : [ Datos.usos[tuso].species ];
							if (txexpurisifn3.find(txuri => spa.includes(txuri))) {
								if (esBorde) { // si es borde...
									cols.push(config.colores[Sesion.taxonesColores[ind]][nivBorde]);
									break;
								}
								else // en otro caso
									porc = 70; // pongo 70 por defecto (no puedo deducir más)
							}
						}		
					}
				}				
				// si es mayor que 0 obtengo color y guardo
				if (porc > 0) // caso sin filtros y no borde: asigno un 10% de bonus y saturo al 100%
					cols.push(getColor(porc + 10, 100, config.colores[Sesion.taxonesColores[ind]]));
			}		
			// si hay algún color...
			if (cols.length > 0)
				return getColorMix(cols);
		}
		// SELECCIÓN DE COLOR SIN FILTRO DE TAXÓN
		ind0 = config.coltesforind; // verde claro (color de teselas de monte)
		// ajuste segundo índice		
		ind1 = esBorde? nivBorde : 5;
	}
	else if (Datos.usos[config.treelessuse].expuris.find(uuri => tesusos.includes(uuri))) { // uso sin árboles
		ind0 = config.coltesforind; // verde (color de teselas de monte)
		ind1 = esBorde? nivBorde : 1; // verde muy claro
	}
	else if (Datos.usos[config.agricuse].expuris.find(uuri => tesusos.includes(uuri))) // uso agrícola
		ind0 = config.coltesagrind; // naranja
	else if (Datos.usos[config.impruse].expuris.find(uuri => tesusos.includes(uuri))) // improductivo
		ind0 = config.coltesimpind; // gris
	else if (Datos.usos[config.wetlanduse].expuris.find(uuri => tesusos.includes(uuri))) // humedal-agua
		ind0 = config.colteshumind; // celeste
	
	// devuelvo color
	return config.colores[ind0][ind1];
}
function popupTesela(tesela) {
	// preparo plantilla para el mustache
	let patchtemp = {};
	patchtemp.iri = tesela.iri;

	// preparo texto del popup para todas las teselas
	const prtiri = applyPrefix(tesela.iri,  config.prefixes);
	const prid = uriToLiteral(tesela.iri);
	patchtemp.patch = getLiteral(dict.patch) + ' ' + prid;
	
	// fuente
	patchtemp.source = prtiri.startsWith("pcos")? getLiteral(dict.sourcecos2018) : getLiteral(dict.sourcemfe50);
	
	// obtengo etiqueta provincia y fecha toma de datos
	if (tesela.province && Datos.provs[tesela.province]) {
		// etiqueta
		if (Datos.provs[tesela.province].label)
			patchtemp.prov = getLiteral(dict.provinceof) + ' ' + getLiteral(Datos.provs[tesela.province].label);
		// fecha
		if (Datos.provs[tesela.province].mfeSourceDate) 
			patchtemp.dataCapture = getLiteral(dict.dataCapture) + ' ' + getDate(Datos.provs[tesela.province].mfeSourceDate);		
	}
	// área
	patchtemp.area = getLiteral(dict.area)+": "+Number((tesela.area/10000).toFixed(2)).toLocaleString(getPreferredLang())+"ha";
	
	// uso del suelo
	// 2021-07-19 reajuste uso del suelo
	if (tesela.infoSoil) {
		const infosoilar = Array.isArray(tesela.infoSoil)? tesela.infoSoil : [tesela.infoSoil];
		let filas = [];
		for (let isoil of infosoilar) {
			if (Datos.usos[isoil.soilUse]) {
				let etuso = getLiteral(Datos.usos[isoil.soilUse].label);
								
				// si hay taxones seleccionados y coincide con el uso, reformateo etuso
				if (Sesion.taxones.length > 0) {
					let incs = [];
					for (let tx of Sesion.taxones) {
						if (Datos.usos[isoil.soilUse].species) {
							const spa = Array.isArray(Datos.usos[isoil.soilUse].species)? Datos.usos[isoil.soilUse].species : [Datos.usos[isoil.soilUse].species];							
							if (Datos.taxones[tx].expuris.find(txuri => spa.includes(txuri)))
								incs.push(tx); // adentro
						}
					}
					// formateo las coincidencias en las listas expandidas de especies
					if (incs.length > 0) {
						etuso += ' ('
						for (let espuri2 of incs) {
							// incluyo nombre especie 2
							etuso += '<strong>' + getTaxonLabel(espuri2, Sesion.nomci, true);  + '</strong>, ';
						}
						// reemplazo final...
						etuso += ')';						
						etuso = etuso.replace(", )", ")");
					}
				}
				
				const vinf = 10*Math.floor(isoil.percOccupation/10);
				const vsup = 10*Math.ceil(isoil.percOccupation/10);
				const vtexto = vinf == vsup? vsup + "%" : vinf + "-" + vsup + "%";
				let fila = {
					porc: isoil.percOccupation,
					texto: "<br> - " + etuso + ": " + vtexto,
				}
				// incluyo fila
				filas.push(fila);
			}			
		}
		if (filas.length > 0) {
			patchtemp.haySoilUses = true;
			patchtemp.soilUses = [];
			// ordeno filas por porcentaje
			filas = filas.sort((a, b) => b.porc - a.porc);
			for (let fila of filas)
				patchtemp.soilUses.push(fila.texto);
		}
	} else if (tesela.soilUse) { // caso por defecto
		// extraigo primer uso válido
		const uuri = Array.isArray(tesela.soilUse)? tesela.soilUse[0] : tesela.soilUse;
		if (uuri != null && Datos.usos[uuri] != undefined) {// si hay uri, muestro
			let etuso = getLiteral(Datos.usos[uuri].label); // etiqueta por defecto	
			// 2021-07-19 caso usos portugueses con especies
			if (Sesion.taxones.length > 0 && Datos.usos[uuri].species != undefined) {
				let incs = [];
				for (let tx of Sesion.taxones) {
					if (Datos.usos[uuri].species != undefined) {
						const spa = Array.isArray(Datos.usos[uuri].species)? Datos.usos[uuri].species : [Datos.usos[uuri].species];
						if (Datos.taxones[tx].expuris.find(txuri => spa.includes(txuri)))
							incs.push(tx); // adentro				
					}
				}
				// formateo las coincidencias en las listas expandidas de especies
				if (incs.length > 0) {
					etuso += ' ('
					for (let espuri2 of incs) {
						// incluyo nombre especie 2
						etuso += '<strong>' + getTaxonLabel(espuri2, Sesion.nomci, true) + '</strong>, ';
					}
					// reemplazo final...
					etuso += ')';						
					etuso = etuso.replace(", )", ")");
				}
			}			
			// incluyo etiqueta
			patchtemp.soilUse = getLiteral(dict.soiluse)+': ' + etuso;
		}
	}
	
	// cobertura arbórea (teselas de monte)
	if (tesela.canopyCoverTreesPercent)
		patchtemp.canopyCover = getLiteral(dict.canopycovertrees)+": "+Math.round(getLiteral(tesela.canopyCoverTreesPercent))+"%";

	// especies (teselas de monte)
	if (tesela.infoSpecies) {
		// incluyo infospecies en un array si hace falta para el análisis
		const infosar = Array.isArray(tesela.infoSpecies)? tesela.infoSpecies : [tesela.infoSpecies];	
		let filas = [];
		for (let i=0; i<infosar.length; i++) {
			// cojo elemento infoSpecies
			const is = infosar[i];			
			if (Datos.taxones[is.species]) {
				let nesp = getTaxonLabel(is.species, Sesion.nomci, true);
				// si hay taxones seleccionados, ajusto formateo si procede
				if (Sesion.taxones.length > 0) {
					let incs = [];
					for (let tx of Sesion.taxones) {
						// REHAGO POR EL TEMA DE QUE EL MFE ESTÁ ANOTADO CON TX DEL IFN3					
						if (is.species === correspondenciaTaxon(tx, "ifn3")) // coincidencia!
							nesp = '<strong>' + nesp + '</strong>';
						else if (correspondenciaTaxonMulti(Datos.taxones[tx].expuris, "ifn3").includes(is.species))
							incs.push(tx);			
					}
					// formateo las coincidencias en las listas expandidas de especies
					if (incs.length > 0) {
						nesp += ' (';
						for (let espuri2 of incs) {
							// incluyo nombre especie 2
							nesp += '<strong>' + getTaxonLabel(espuri2, Sesion.nomci, true) + '</strong>, ';							
						}
						// reemplazo final...
						nesp += ')';						
						nesp = nesp.replace(", )", ")");
					}
				}				
				// preparo fila				
				const vinf = 10*Math.floor(is.percOccupation/10);
				const vsup = 10*Math.ceil(is.percOccupation/10);
				let vtexto = vinf == vsup? vsup + "%" : vinf + "-" + vsup + "%";
				// 2024-6 incluyo devStage
				if (is.devStage)
					vtexto += " (" + getLiteral(is.devStage).toLowerCase() + ")";
				let fila = {
					porc: is.percOccupation,
					texto: "<br> - " + nesp + ": " + vtexto,
				}
				// incluyo fila
				filas.push(fila);
			}			
		}
		if (filas.length > 0) {
			patchtemp.hayInfoSpecies = true;
			patchtemp.infoSpecies = [];
			// ordeno filas por porcentaje
			filas = filas.sort((a, b) => b.porc - a.porc);
			for (let fila of filas)
				patchtemp.infoSpecies.push(fila.texto);
		}
	}
	// obtengo el popup y lo devuelvo
	return Mustache.render(patchPopupTemplate, patchtemp);
}


function pintarTeselas(turis) {
	// preparo teselas a pintar en GeoJSON
	let teselas = []; // teselas a pintar
	let pturis = []; // uris de las teselas a pintar
	for (let turi of turis) {
		// si está pintada no sigo
		if (!Sesion.tesPintadas[turi]) {
			// marco como pintada, pero no guardo aún la capa de Leaflet
			Sesion.tesPintadas[turi] = true;
			const otes = Datos.teselas[turi];
			// sólo sigo si hay geometría
			if (otes.geometry) {
				// inicializo objeto
				let patch = {
					"type": "Feature",
					"properties" : {}		
				};
				// iri
				patch.properties.iri = turi;
				// geometría
				patch.geometry = otes.geometry;
				// guardo en las listas
				teselas.push(patch);
				pturis.push(turi);
			}		
		}
	}
	
	// pinto las teselas
	Layers.tess.addData(teselas);	
	
	// guardo los layers (habrá sobreescrituras, pero esto es rápido)
	for (let layer of Layers.tess.getLayers()) {
		const iri = layer.feature.properties.iri;
		Sesion.tesPintadas[iri] = layer;
	}
	
	// pongo popups a pturis
	ajustarPopupsTeselas(pturis, true);
	
	// mando la capa de teselas al fondo
	Layers.tess.bringToBack();
	
	// devuelvo las teselas pintadas
	return pturis.length;
}

function ajustarColorTeselas(turis, todas) { // todas o sólo monte
	//console.log("#teselas ajustar color: " + turis.length);
	//console.time("ajustarColorTeselas");
	
	/* ahora lo calculo al incluir el taxón
	// HAY QUE TENER EN CUENTA QUE EL MFE Y EL COS ESTÁN ANOTADOS CON TX DEL IFN3
	// debido a esto tengo que convertir los taxones expuris de tx al ifn3
	// lo hago aquí para aprovecharlo para todo el lote de teselas (al ser común)
	const corrtxmulti = [];
	for (let tx of Sesion.taxones) 
		corrtxmulti.push( correspondenciaTaxonMulti(Datos.taxones[tx].expuris, "ifn3") );
	*/
	
	// ajusto color tesela a tesela
	for (let turi of turis) {
		// el DataManager precalcula si la tesela es forestal
		if (Sesion.tesPintadas[turi] && typeof Sesion.tesPintadas[turi] === 'object'  && Datos.teselas[turi]) {
			if (todas || Datos.teselas[turi].forestal) {
				// obtengo colores y ajusto estilo
				const colint = colorTesela(Datos.teselas[turi], false);
				const colext = colorTesela(Datos.teselas[turi], true);
				Sesion.tesPintadas[turi].setStyle( {fillColor: colint, color: colext} );			
			}		
		}
		/* TODO: previo
		if (Sesion.tesPintadas[turi] && typeof Sesion.tesPintadas[turi] === 'object' && Datos.teselas[turi].soilUse && Datos.usos[config.forestuse]) {
			const tesusos = Array.isArray(Datos.teselas[turi].soilUse)? Datos.teselas[turi].soilUse : [ Datos.teselas[turi].soilUse ];	
			if (todas || Datos.usos[config.forestuse].expuris.filter(uuri => tesusos.includes(uuri)).length > 0) {
				// obtengo colores y ajusto estilo
				const colint = colorTesela(Datos.teselas[turi], false);
				const colext = colorTesela(Datos.teselas[turi], true);
				Sesion.tesPintadas[turi].setStyle( {fillColor: colint, color: colext} );			
			}
		}*/
	}
	
	//console.timeEnd("ajustarColorTeselas");
}

function ajustarPopupsTeselas(turis, todas) {
	// ajusto popup tesela a tesela (si son de monte, las del resto no cambian)
	for (let turi of turis) {
		// el DataManager precalcula si la tesela es forestal
		if (Sesion.tesPintadas[turi] && typeof Sesion.tesPintadas[turi] === 'object'  && Datos.teselas[turi]) {
			if (todas || Datos.teselas[turi].forestal) {
				if (Sesion.tesPintadas[turi].getPopup())
					Sesion.tesPopupsRegenerar[turi] = true; // sólo marco las teselas que requieren regenerar el popup
				else {
					// pongo popup hago realce
					const texto = popupTesela(Datos.teselas[turi]);
					Sesion.tesPintadas[turi].bindPopup(texto)
						.on({
							popupopen: function(e) { // realce
								let layer = e.target;
								if (Sesion.estado.mapType === config.mapConfig.mapType[1]) // capa satélite
									layer.setStyle({
										fillOpacity: 0.3, //0.2,
										weight: 1.2 //0.9
									});
								else
									layer.setStyle({
										fillOpacity: 0.4,
										weight: 1.5
									});
							},
							popupclose: function(e) { // quitar realce
								let layer = e.target;
								if (Sesion.estado.mapType === config.mapConfig.mapType[1]) // capa satélite
									layer.setStyle({
										fillOpacity: 0.05, //0.1,
										weight: 0.4 //0.3
									});							
								else
									layer.setStyle({
										fillOpacity: 0.3,
										weight: 0.5
									});
							}
						});			
				}
			}
		}
	}
}

function quitarTeselas() {
	console.info("Borrando capa de teselas...");
	//console.time("Limpieza de teselas");
	// es algo más rápido eliminar la capa del mapa y cargar una nueva
	Layers.tess.remove(); 
	Layers.tess = inicializarTeselas();
	Layers.tess.bringToBack();
	// inicializo la lista de teselas pintadas
	Sesion.tesPintadas = {};
	// inicializo la lista de teselas con popups para regenerar
	Sesion.tesPopupsRegenerar = {};
	//console.timeEnd("Limpieza de teselas");
}

export { inicializarTeselas, pintarTeselas, ajustarColorTeselas, ajustarPopupsTeselas, popupTesela, quitarTeselas };